// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import GaloIndustriesLanding from './GaloIndustriesLanding';
import GaloProjectDetailPage from './GaloProjectDetailPage';
import GaloBlogPage from './GaloBlogPage';
import GaloBlogPost from './GaloBlogPost';
import GaloProjectsPage from './GaloProjectsPage';
import GaloAboutPage from './GaloAboutPage';
import Industry4Landing from './Industry4Landing';
import GaloServicesPage from './GaloServicesPage';
import GaloCareersPage from './GaloCareersPage';
import ContactPage from './ContactPage';
import Industry40EvalTool from './Industry40EvalTool';
import GaloInnovationLab from './GaloInnovationLab';
import GaloTeamHub from './GaloTeamHub';
import PLCProgrammingAssistant from './PLCProgrammingAssistant';
import PLCTest from './PLCTest';
import PLCBottleFlowchart from './PLCBottleFlowchart';


import { SeoConfig } from './utils/seoConfig'; // New SEO configuration utility
import GaloEUProject from './GaloEuProject';
// Scroll to top on navigation
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Analytics tracking for page changes
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);
  
  return null;
};

// Sitemap generation hint
// For production, a sitemap.xml should be generated at build time
// This could be done with a script that reads your routes configuration

function App() {
  return (
    <HelmetProvider>
      {/* Default SEO tags that will be present on all pages */}
      <SeoConfig
        title="Galo Industries | Automation & Manufacturing Solutions"
        description="Galo Industries provides cutting-edge automation solutions for the manufacturing industry with expertise in robotics, AI, and IoT integration."
        canonicalUrl="https://galo-industries.com" // This will be extended per route
        openGraph={{
          type: 'website',
          locale: 'en_US',
          site_name: 'Galo Industries',
        }}
        twitter={{
          handle: '@galoindustries',
          site: '@galoindustries',
          cardType: 'summary_large_image',
        }}
      />
      
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<GaloIndustriesLanding />} />
          <Route path="/projects" element={<GaloProjectsPage />} />
          <Route path="/project/:projectId" element={<GaloProjectDetailPage />} />
          
          {/* Blog Routes */}
          <Route path="/blog" element={<GaloBlogPage />} />
          <Route path="/blog/:slug" element={<GaloBlogPost />} />
          <Route path="/blog/category/:category" element={<GaloBlogPage />} />
          <Route path="/blog/tag/:tag" element={<GaloBlogPage />} />
          
          <Route path="/about" element={<GaloAboutPage />} />
          <Route path="/services" element={<GaloServicesPage />} />
          <Route path="/careers" element={<GaloCareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
                    <Route path="/innovation" element={<GaloEUProject />} />

          <Route path="/smartfactories" element={<Industry4Landing />} />
          <Route path="/Industry40EvalTool" element={<Industry40EvalTool />} />
          <Route path="/GaloInnovationLab" element={<GaloInnovationLab />} />
          <Route path="/GaloTeamHub" element={<GaloTeamHub />} />
                    <Route path="/PLCProgrammingAssistant" element={<PLCProgrammingAssistant />} />
<Route path="/plctest" element={<PLCTest />} />
<Route path="/PLCBottleFlowchart" element={<PLCBottleFlowchart />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;